import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function LoadingMetrics() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px", flexDirection: 'column', gap: 2 }}>
      <CircularProgress size={60} color="primary" />
      <Typography variant="body1" color="text.secondary">Carregando métricas...</Typography>
    </Box>
  );
}
